import React, { useState, useEffect } from 'react';
import {
  TextField, Typography, Button, Alert,
  IconButton, InputAdornment
} from '@mui/material';
import { Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import useMessages from '../../../hooks/useMessages';
import LoginLayout from '../../commun/LoginLayout';
import { goToDashboard } from '../../commun/navigation';

import './auth.css';               

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '', motDePasse: '', verificationCode: '',
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [showResendButton,      setShowResendButton]      = useState(false);
  const [showVerificationInput, setShowVerificationInput] = useState(false);

  const navigate = useNavigate();
  const { messages, handleSuccess, handleError } = useMessages();

useEffect(() => {
  const token = localStorage.getItem('authToken');
  const userType = localStorage.getItem('userType');

  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    if (userType) {
      switch (userType.toLowerCase()) {
        case 'admin':
          navigate('/admin/dashboard');
          break;
        case 'recruteur':
          navigate('/recruteur');
          break;
        case 'entreprise':
          navigate('/entreprise');
          break;
        case 'agent':
          navigate('/agent/dashboard');
          break;
        case 'commercial':
          navigate('/commercial/dashboard');
          break;
        case 'candidat':
          navigate('/candidat');
          break;
        default:
          navigate('/login');
          break;
      }
    }
  }
}, [navigate]);


  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(f => ({ ...f, [name]: value }));
  };


  const handleLogoClick = () => {
  goToDashboard(navigate);
};
  const handleSubmit = async e => {





    e.preventDefault();
    try {
      const { data } = await axios.post('/api/auth/login', {
        email: formData.email, motDePasse: formData.motDePasse,
      });

      localStorage.setItem('authToken', data.token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

      localStorage.setItem('userId',   data.userId);
      localStorage.setItem('userType', data.userType);
      localStorage.setItem("isUserPrincipal", data.isUserPrincipal);
      localStorage.setItem("loginTime", Date.now().toString());


      goToDashboard(navigate);

      if (data.userType === 'entreprise') {
        localStorage.setItem('entrepriseName', data.entrepriseName);
        localStorage.setItem('entrepriseId', data.entrepriseId);
        try {
          const entrepriseRes = await axios.get(`/api/entreprise/profil/${data.userId}`, {
            headers: { Authorization: `Bearer ${data.token}` }
          });
          const logo = entrepriseRes.data.logo;
          if (logo) {
            localStorage.setItem('entrepriseLogo', logo);
          }
        } catch (logoErr) {
          console.error('Erreur récupération logo entreprise:', logoErr);
        }
        navigate('/entreprise');
      }
       else if (data.userType === 'recruteur') {
        localStorage.setItem('recruteurName', data.recruteurName);
        navigate('/recruteur');
      } else if (data.userType === 'admin') {
        localStorage.setItem('userName', data.userName);
        navigate('/admin/dashboard');
      } else if (data.userType === 'agent') {
        localStorage.setItem('userName', data.userName);
        navigate('/agent/dashboard');
      } else if (data.userType === 'commercial') {
        localStorage.setItem('userName', data.userName);
        navigate('/commercial/dashboard');
        } else if (data.userType === 'candidat') {
        localStorage.setItem('userName', data.userName);
        navigate('/candidat/dashboard');
      }


      handleSuccess('Connexion réussie.');
      setFormData({ email: '', motDePasse: '', verificationCode: '' });
    } catch (err) {
  const msg = err.response?.data?.message || err.message;

  if (err.response?.data?.requiresVerification) {
    setShowVerificationInput(true);
    setShowResendButton(true);
    handleError("Votre compte n'est pas encore vérifié. Veuillez saisir le code.");
  } else if (err.response?.data?.statut === 'pending' || err.response?.data?.statut === 'inactive') {
    handleError("Votre compte n’a pas encore été approuvé ou est inactif.");
  } else {
    handleError(msg);
  }
}

  };

  const handleResendVerification = async () => {
    try {
      await axios.post('/api/auth/resend-verification', { email: formData.email });
      handleSuccess('Code renvoyé à votre adresse email.');
    } catch {
      handleError("Erreur lors de l'envoi du code.");
    }
  };

  const handleVerification = async e => {
    e.preventDefault();
    try {
      await axios.post('/api/auth/verify', {
        email: formData.email, verificationCode: formData.verificationCode,
      });
      handleSuccess('Compte vérifié avec succès.');
      setShowResendButton(false);
      setShowVerificationInput(false);
    } catch {
      handleError('Code de vérification incorrect.');
    }
  };

  return (
    <LoginLayout>
      <Typography variant="h5" align="center" gutterBottom>
        Connexion
      </Typography>

      {messages.error   && <Alert severity="error"   className="mb-2">{messages.error}</Alert>}
      {messages.success && <Alert severity="success" className="mb-2">{messages.success}</Alert>}

      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          name="email"
          fullWidth
          required
          margin="normal"
          value={formData.email}
          onChange={handleChange}
        />

        <TextField
          label="Mot de passe"
          name="motDePasse"
          type={isPasswordVisible ? 'text' : 'password'}
          fullWidth
          required
          margin="normal"
          value={formData.motDePasse}
          onChange={handleChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setIsPasswordVisible(v => !v)}>
                  {isPasswordVisible ? <Eye /> : <EyeOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button type="submit" fullWidth variant="contained" className="auth-submit">
          Se connecter
        </Button>
      </form>

      {showVerificationInput && (
        <form onSubmit={handleVerification}>
          <TextField
            label="Code de vérification"
            name="verificationCode"
            fullWidth
            required
            value={formData.verificationCode}
            onChange={handleChange}
            margin="normal"
          />
          <Button type="submit" variant="outlined" fullWidth className="mt-1">
            Vérifier le compte
          </Button>
        </form>
      )}

      {showResendButton && (
        <Button onClick={handleResendVerification} fullWidth className="mt-2">
          Renvoyer le code de vérification
        </Button>
      )}

      <Typography variant="body2" align="center" className="mt-3">
        <a href="/reset-password" className="auth-link">Mot de passe oublié ?</a>
      </Typography>

      <Typography variant="body2" align="center" className="mt-1">
        Vous n’avez pas de compte ?{' '}
        <a href="/signup" className="auth-link">Inscrivez‑vous</a>
      </Typography>
    </LoginLayout>
  );
};

export default Login;
